import Type from "../Type";

const initState = {
    isShow:false,
    isMinimized:false,
    className:'',
    arrLabelShow:[  {key: 'zone', text:'Quy hoạch', active: false},
                    {key: 'info', text:'Thửa đất', active: false},
                    {key: 'result', text:'Tìm kiếm', active: false} ],
    routeContent:'drawingManager',
    routeFrom:'',
}

const RightPanelReducer = (state=initState,{type,route,value})=>
{
    if (type === Type.SET_STATE_RIGHT_PANEL)
        return {
            ...state,
            [route]:value
        }
    return state;
}

export default RightPanelReducer
